import { t } from 'i18next';

import Picker from '#/components/Picker/Picker';
import { PlanPickerSubText } from '#/plugins/paywall/components';
import { getPickerItemsFromPlans } from '#/plugins/paywall/utils';

import { PickPlanStepProps } from '../../types';

// TODO: handle this better
export const getDescription = () => {
  const webOnlyKey = 'web.iap.description';
  let result = t(webOnlyKey);

  // check if we have a web only description
  if (result && result !== webOnlyKey) {
    return result;
  }

  const allPlatformsKey = 'iap.description';
  result = t(allPlatformsKey);

  // fall back to the default description. if it's also missing, don't display anything.
  return result === allPlatformsKey ? null : result;
};

const PickPlanStep = ({
  plans,
  selectedPlan,
  nextStep,
  onPlanChange,
}: PickPlanStepProps) => {
  const description = getDescription();

  const plansToPickerItemMap = getPickerItemsFromPlans(plans);

  const handlePlanSelect = (planId: string) => {
    const plan = plans?.find(({ id }) => id === planId);

    if (!plan) {
      return;
    }

    onPlanChange(plan);
    nextStep();
  };

  return (
    <>
      <Picker
        items={plansToPickerItemMap}
        onContinue={handlePlanSelect}
        selectedItemId={selectedPlan?.id}
      />
      {description && (
        <PlanPickerSubText $isCentered>{description}</PlanPickerSubText>
      )}
    </>
  );
};

PickPlanStep.displayName = 'PickPlanStep';

export default PickPlanStep;
